export default __webpack_public_path__ + "static/media/toucan3x.848aafb6.png";